<div class="content" role="main">
  <router-outlet></router-outlet>
</div>